import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = ({ category, articleTitle, items }) => {
  // If items prop is provided, use it for custom breadcrumbs
  if (items) {
    return (
      <nav aria-label="Breadcrumb" className="mb-8">
        <ol className="flex items-center space-x-2 text-sm text-apple-300">
          <li>
            <Link 
              to="/" 
              className="flex items-center hover:text-sortio-primary transition-colors duration-200"
              aria-label="Home"
            >
              <Home className="w-4 h-4" />
            </Link>
          </li>
          
          {items.map((item, index) => (
            <React.Fragment key={index}>
              <li>
                <ChevronRight className="w-4 h-4 text-apple-400" />
              </li>
              <li>
                {item.href && index < items.length - 1 ? (
                  <Link 
                    to={item.href}
                    className="hover:text-sortio-primary transition-colors duration-200"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-apple-50 font-medium" aria-current="page">
                    {item.label}
                  </span>
                )}
              </li>
            </React.Fragment>
          ))}
        </ol>
      </nav>
    );
  }
  
  // Original implementation for articles
  return (
    <nav className="text-sm mb-4">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-400 hover:underline">Home</Link>
          {category || articleTitle ? <ChevronRight size={16} className="mx-2" /> : null}
        </li>
        <li className="flex items-center">
          <Link to="/articles" className="text-blue-400 hover:underline">Articles</Link>
          {category || articleTitle ? <ChevronRight size={16} className="mx-2" /> : null}
        </li>
        {category && (
          <li className="flex items-center">
            <span className="text-blue-400">{category}</span>
          </li>
        )}
        {articleTitle && (
          <>
            <ChevronRight size={16} className="mx-2" />
            <li className="text-gray-400">{articleTitle}</li>
          </>
        )}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
